import { render, staticRenderFns } from "./admin-customers.vue?vue&type=template&id=c468e854"
import script from "./admin-customers.vue?vue&type=script&lang=js"
export * from "./admin-customers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports